import { createSlice } from "@reduxjs/toolkit";

// 1. Use concise default state, clean up reducer logic, add comments for clarity
// No logic change, just code clarity and comments
const defaultSortingState = {
  isSortDate: false,
  isSortName: false,
  isOtherSort: false,
  sortDate: "desc",
  sortName: "asc",
  otherSort: "desc",
  showDisabled: false,
  isSorting: false,
};

const defaultFilterState = {
  isFilter: false,
};

export const initialState = {
  sorting: {}, // { [moduleName]: sortingState }
  filter: {}, // { [moduleName]: filterState }
};

const filterSortingSlice = createSlice({
    name: "filterSorting",
    initialState,
    reducers: {
    setModuleSorting: (state, action) => {
      const { module, sortingState } = action.payload;
      // Ensure the module has a proper initial state before updating
      if (!state.sorting[module]) {
        state.sorting[module] = { ...defaultSortingState };
      }
      state.sorting[module] = { ...state.sorting[module], ...sortingState };
        },
    resetModuleSorting: (state, action) => {
      const module = action.payload;
      state.sorting[module] = { ...defaultSortingState };
        },
    clearAllSorting: (state) => {
      state.sorting = {};
        },
    setModuleFilter: (state, action) => {
      const { module, filterState } = action.payload;
      state.filter[module] = { ...state.filter[module], ...filterState };
        },
    resetModuleFilter: (state, action) => {
      const module = action.payload;
      state.filter[module] = { ...defaultFilterState };
        },
    clearAllFilter: (state) => {
      state.filter = {};
        },
    },
});

export const {
  setModuleSorting,
  resetModuleSorting,
  clearAllSorting,
  setModuleFilter,
  resetModuleFilter,
  clearAllFilter,
} = filterSortingSlice.actions;

// Selector to get sorting state for a module
export const selectModuleSorting = (state, module) => {
  const moduleSorting = state?.filterSorting?.sorting?.[module];
  if (!moduleSorting) {
    // If module doesn't exist, return default state
    return { ...defaultSortingState };
  }
  return moduleSorting;
};

// Selector to get filter state for a module
export const selectModuleFilter = (state, module) =>
  state?.filterSorting?.filter?.[module] || defaultFilterState;

export default filterSortingSlice.reducer;
  